import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap, from, of } from 'rxjs';
import * as ObjectActions from './scoped-form.actions';
import { HelperService } from '../../../shared/service/helper.service';
import { ScopedFormService } from '../../../shared/service/filter/scoped-form.service';
import { IScopedFormDropdownData, IScopedFormDropdownResponse } from '../../../shared/component/filter/filter.class';

@Injectable()
export class FilterScopedFormEffects {
  constructor(
    private readonly actions$: Actions<ObjectActions.FilterScopedFormActions>,
    public service: ScopedFormService,
    public helperService: HelperService,
  ) {}

  loadFilterForms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GET_SCOPED_FORMS),
      switchMap((objectData: ObjectActions.GetScopedForms) => {
        return from(this.service.getScopedForms()).pipe(
          switchMap((response: IScopedFormDropdownData[]) => {
            return of(
              new ObjectActions.GetScopedFormsCompleted(
                response.map((rowData: IScopedFormDropdownResponse): IScopedFormDropdownData => {
                  return {
                    ...rowData,
                    id: rowData.formTableId,
                    name: this.helperService.getNameWithArchiveLabel(
                      rowData.formIsArchived,
                      `${rowData.formId} - ${rowData.formVersionName}`,
                    ),
                  };
                }),
              ),
            );
          }),
          catchError(() => {
            return of(new ObjectActions.GetScopedFormsCompleted([]));
          }),
        );
      }),
    ),
  );
}
